import { render, staticRenderFns } from "./ContentOptions.vue?vue&type=template&id=986de0ba&scoped=true&"
import script from "./ContentOptions.vue?vue&type=script&lang=js&"
export * from "./ContentOptions.vue?vue&type=script&lang=js&"
import style0 from "./ContentOptions.vue?vue&type=style&index=0&id=986de0ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986de0ba",
  null
  
)

export default component.exports